import React from 'react';
import { Routes, Route } from "react-router-dom";
import Home from "../pages/Home"
import Services from "../pages/Services";
import Company from "../pages/Company";
import Blogs from "../pages/Blogs";
import FAQ from "../pages/FAQ";
import Contact from "../pages/Contact";
import ProductDetail from '../pages/Productdetail';
import { BLOG } from '../Redux/common/constant';
import BlogListpub from '../components/Blog/BlogListpub';
import BlogDetailsPub from '../components/Blog/BlogDetailsPub';
import Customers from '../pages/Installations';



function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/services" element={<Services />} />
      <Route path="/company" element={<Company />} />
      <Route path="/blogs" element={<Blogs />} />
      <Route path="/customer" element={<Customers />} />
      <Route path="/faq" element={<FAQ />} />
      <Route path="/contact" element={<Contact />} />
       <Route path="/productdetail/:id" element={<ProductDetail/>} />
       <Route path="/blogs-news" element={<BlogListpub />} />
      <Route path="/blog-details/:id" element={<BlogDetailsPub />} />
    </Routes>
  );
}

export default AppRoutes;
